import type { Props } from "../SheetV1.types";

export const getPropDefaults = (): Omit<
  Required<Props>,
  "id" | "extraData" | "headline" | "ocAriaLabel" | "url" | "base64Url"
> => ({
  open: false,
  headlineLevel: 2,
  hideHeader: false,
  hideCloseButton: false,
  hideBackButton: false,
  fullHeight: false,
  noContentPadding: false,
  allowedErrorStatusCodes: [],
  discardContentOnInactive: false,
});
